import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MatPaginator, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ProdutoFidelidade } from 'src/app/models/produto-fidelidade';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FidelidadeProdutoService } from 'src/app/services/fidelidade-produto.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-resgatar-pontos-modal',
  templateUrl: './resgatar-pontos-modal.component.html',
  styleUrls: ['./resgatar-pontos-modal.component.scss']
})
export class ResgatarPontosModalComponent implements OnInit {
  produtosFiltrados: ProdutoFidelidade[] = [];
  carregando = true;
  campoOrdenacao = 'produto';
  ordenarDesc = false;
  editavel = true;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 9;
  saldo = 0;
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;
  public config: PerfectScrollbarConfigInterface = {};
  constructor(public dialogRef: MatDialogRef<ResgatarPontosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private carregandoService: CarregandoService, public utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService, private fidelidadeProdutoService: FidelidadeProdutoService, private produtoService: ProdutoService) {
    this.saldo = data.saldo;
  }

  ngOnInit(): void {
    this.buscarProdutosFidelidade();
  }

  buscarProdutosFidelidade() {
    this.carregandoService.mostra('buscarProdutosFidelidade');

    this.fidelidadeProdutoService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina, this.campoOrdenacao, (this.ordenarDesc ? 'desc' : 'asc'), true).subscribe((data: any) => {

      this.produtosFiltrados = data.itens;
      this.carregandoService.esconde('buscarProdutosFidelidade');
      this.produtosFiltrados.forEach(produto => {
        produto.imagem$ = this.buscarImagemProduto(produto.id);
        // produto.imagem$ = this.fidelidadeProdutoService.consultarFotoProdutoPorId(produto.id)
        //   .map(m => m !== null && m !== undefined ? this.utilitarioService.toBase64ComInicio(m) : Promise.resolve('./assets/img/placeholder.jpg')).toPromise();
        produto.imagem$.then(p => { produto.buscouImagem = true; });
      });
      this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(data);
      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = data.total;
      this.carregando = false;

    }, (erro) => {
      this.carregandoService.esconde('buscarProdutosFidelidade');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarImagemProduto(idProduto): Promise<string> {
    const imagem = await this.produtoService.consultarImagemProdutoPorId(idProduto).toPromise();

    if (imagem && imagem.url) {
      return Promise.resolve(imagem.url);
    } else if (imagem && imagem.raw) {
      return Promise.resolve('data:image/jpg;base64,' + imagem.raw);
    } else {
      return Promise.resolve('./assets/img/inversor.png');
    }
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarProdutosFidelidade();
  }

  voltar() {
    this.dialogRef.close();
  }

  resgatar(produto) {
    swal({
      title: 'Atenção!!',
      text:'Deseja realmente resgatar o produto ' + produto.produto,
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false,
      type: 'warning'
    }).then((result) => {
      if (result.value) {
        this.dialogRef.close(produto.id);
      }
    });
  }
}